import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Loader2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const AuthCallback = () => {
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || '';
    const sessionId = new URLSearchParams(hash.replace('#', '')).get('session_id');

    const finish = async () => {
      if (!sessionId) {
        navigate('/admin/login', { replace: true });
        return;
      }
      try {
        await axios.post(`${API}/auth/session`, {}, {
          headers: { 'X-Session-ID': sessionId },
          withCredentials: true,
        });
        window.history.replaceState(null, '', '/admin');
        navigate('/admin', { replace: true });
      } catch (e) {
        const detail = e?.response?.data?.detail || 'Login failed. Please try again.';
        navigate('/admin/login', { replace: true, state: { error: detail } });
      }
    };
    finish();
  }, [navigate]);

  return (
    <div
      data-testid="auth-callback-loading"
      className="min-h-screen bg-black text-gold flex flex-col items-center justify-center gap-4"
    >
      <Loader2 className="w-10 h-10 animate-spin" />
      <p className="text-lg">Signing you in…</p>
    </div>
  );
};

export default AuthCallback;
